module.exports = __webpack_public_path__ + "img/BOR_lodging.c1872992.jpg";